import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { Grid, HStack, Image, VStack } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OfferCard from 'features/Insurance/components/OfferCard';
import { GroupItemWithOffersCoverage } from 'features/Insurance/types';

interface Props {
  group: GroupItemWithOffersCoverage;
}

export const InsuranceGroup: FC<Props> = ({ group }) => {
  return (
    <VStack
      alignItems="flex-start"
      background="grey.100"
      border="1px solid"
      borderColor="border"
      borderRadius="radius-8"
      gap="space-24"
      padding="space-24"
    >
      <HStack gap="space-16">
        <VStack
          bg="grey.200"
          borderRadius="radius-12"
          boxSize="space-40"
          flexShrink={0}
          padding="space-4"
        >
          <Image height="100%" src={group.icon} width="100%" />
        </VStack>
        <VStack alignItems="flex-start" gap="space-0">
          <Heading>{group.title}</Heading>
          <Text>{group.description}</Text>
        </VStack>
      </HStack>
      <Grid gap="space-24" templateColumns="repeat(3, minmax(250px, 288px))">
        {group.offers.map((offer) => (
          <OfferCard
            as={Link}
            isCovered={offer.isCovered}
            isCoveredFromPlan={offer.isCoveredFromPlan}
            key={offer.path.pathname}
            offer={offer}
            to={{ ...offer.path, state: { from: 'all-offers' } }}
          />
        ))}
      </Grid>
    </VStack>
  );
};
